import type { FC } from 'react';
import { FieldDescriptor, FieldDescriptorProps } from '../../atoms/field-descriptor.component';
import { CommonFieldAtomProps } from '../../atoms/types';
import { HelperTextStyles } from './helper-text.styles';

type CommonProps = Pick<CommonFieldAtomProps, 'disabled' | 'hasError'> & FieldDescriptorProps;

interface HelperTextProps extends CommonProps {
  disabled?: boolean;
  hasError?: boolean;
}

export const HelperText: FC<React.PropsWithChildren<HelperTextProps>> = ({ children, disabled, hasError, ...rest }) => {
  const styles = HelperTextStyles.helperText({ disabled, hasError });
  return (
    <FieldDescriptor css={styles} {...rest}>
      {children}
    </FieldDescriptor>
  );
};
